import * as React from "react"
import { graphql } from "gatsby"
import * as styles from "./FormattedText.css"

export type FormattedTextProps = {
  value: string
}

export default function FormattedText(props: FormattedTextProps) {
  return (
    <div
      className={styles.formattedText}
      dangerouslySetInnerHTML={{
        __html: props.value,
      }}
    />
  )
}

export const query = graphql`
  fragment FormattedTextContent on FormattedText {
    value
  }
`